export const trans = (id) => {
    return ({
        type:"TRANS",
        tr:id
    })
}